import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "@mui/material/utils/createSvgIcon";
import svgIconClasses from "@mui/material/SvgIcon/svgIconClasses";
import formControlLabelClasses from "@mui/material/FormControlLabel/formControlLabelClasses";
import radioClasses from "@mui/material/Radio/radioClasses";
import { stripUnit } from "../../styles/utils/utils";
export const MuiRadioTheme = (dt) => {
    const dotWidth = `${(stripUnit(dt.action.default) - stripUnit(dt.action.handle)) / 2}px`;
    const PixelRadio = createSvgIcon(null, "PixelRadio");
    const PixelRadioChecked = createSvgIcon(null, "PixelRadioChecked");
    return {
        defaultProps: {
            disableRipple: true,
            icon: _jsx(PixelRadio, {}),
            checkedIcon: _jsx(PixelRadioChecked, {}),
        },
        styleOverrides: {
            root: {
                paddingRight: dt.button.gap,
                "&:hover": {
                    background: "transparent",
                },
                [`& .${svgIconClasses.root}`]: {
                    borderRadius: dt.borderRadius.pill,
                    width: dt.action.default,
                    height: dt.action.default,
                    backgroundColor: dt.color.surface.key,
                    boxShadow: `inset 0 0 0 ${dt.input.shape.border} ${dt.color.outline}`,
                },
                [`.${formControlLabelClasses.root} & + .${formControlLabelClasses.label}`]: {
                    marginBottom: 0,
                },
                [`input:hover ~ .${svgIconClasses.root}, &:is(.Pxl-demo-hover, [data-demostate=hover]) .${svgIconClasses.root}`]: {
                    boxShadow: `inset 0 0 0 ${dt.input.shape.border} ${dt.color.onSurface.key}`,
                },
                [`&.${radioClasses.disabled}[class] .${svgIconClasses.root}`]: {
                    backgroundColor: dt.color.surface.key,
                },
            },
            colorPrimary: Radiocolors(dt, "primary", dotWidth),
            colorSecondary: Radiocolors(dt, "secondary", dotWidth),
        },
    };
};
const Radiocolors = (dt, color, dotWidth) => {
    return {
        [`&.Mui-focusVisible .${svgIconClasses.root}, input:focus ~ .${svgIconClasses.root}, &:is(.Pxl-demo-focus, [data-demostate=focus])[class] .${svgIconClasses.root}`]: {
            boxShadow: `${dt.state.focus[color]}, inset 0 0 0 ${dt.input.shape.border} ${dt.color.onSurface.key}`,
        },
        [`input:active ~ .${svgIconClasses.root}, &:is(.Pxl-demo-active, [data-demostate=active]) .${svgIconClasses.root}`]: {
            backgroundColor: dt.cta.outlined.color.background[color].pressed,
        },
        [`&.${radioClasses.disabled} .${svgIconClasses.root}`]: {
            boxShadow: `inset 0 0 0 ${dt.input.shape.border} ${dt.cta.outlined.color.border[color].disabled}`,
        },
        [`&.${radioClasses.checked}`]: {
            svg: {
                boxShadow: `inset 0 0 0 ${dotWidth} ${dt.cta.contained.color.background[color].active}, inset 0 0 0 ${dt.action.default} ${dt.cta.contained.color.text[color].default}`,
            },
            [`input:hover ~ .${svgIconClasses.root}, &:is(.Pxl-demo-hover, [data-demostate=hover]) .${svgIconClasses.root}`]: {
                boxShadow: `inset 0 0 0 ${dotWidth} ${dt.cta.contained.color.background[color].hover}, inset 0 0 0 ${dt.action.default} ${dt.cta.contained.color.text[color].default}`,
            },
            [`&.Mui-focusVisible .${svgIconClasses.root}, input:focus ~ .${svgIconClasses.root}, &:is(.Pxl-demo-focus, [data-demostate=focus])[class] .${svgIconClasses.root}`]: {
                boxShadow: `inset 0 0 0 ${dotWidth} ${dt.cta.contained.color.background[color].hover}, inset 0 0 0 ${dt.action.default} ${dt.cta.contained.color.text[color].default}, ${dt.state.focus[color]}`,
            },
            [`input:active ~ .${svgIconClasses.root}, &:is(.Pxl-demo-active, [data-demostate=active]) .${svgIconClasses.root}`]: {
                boxShadow: `inset 0 0 0 ${dotWidth} ${dt.cta.contained.color.background[color].pressed}, inset 0 0 0 ${dt.action.default} ${dt.cta.contained.color.text[color].default}`,
            },
            [`&.${radioClasses.disabled}`]: {
                svg: {
                    boxShadow: `inset 0 0 0 ${dotWidth} ${dt.cta.contained.color.background[color].disabled}, inset 0 0 0 ${dotWidth} ${dt.cta.contained.color.text[color].default}, inset 0 0 0 ${dt.action.default} ${dt.cta.contained.color.text[color].disabled}`,
                },
            },
        },
    };
};
